import React, { useCallback, useState } from 'react'
import { Modal, gaEvent, themeColor } from 'shared'

import teaserImage from './create_fundraising_event_modal.svg'
import { CreateFundraisingEventButtonProps, CreateFundraisingEventButtonModalContentProps } from './types'

export const CreateFundraisingEventButton = (props: CreateFundraisingEventButtonProps) => {
  const [show, setShow] = useState(false)

  const handleClick = useCallback(() => {
    gaEvent('engagement', 'click fe_modal_open_link')
    setShow(true)
  }, [])

  const onHide = useCallback(() => {
    gaEvent('engagement', 'click fe_modal_close_link')
    setShow(false)
  }, [])

  return (
    <div className="w-full mb-1">
      <strong>{I18n.t('projects.show.stats.create_fundraising_event_teaser')}&nbsp;</strong>
      <a onClick={handleClick} style={{ color: themeColor('green-800') }}>
        {I18n.t('projects.show.stats.create_fundraising_event_button')}
      </a>

      <Modal
        show={show}
        onHide={onHide}
        content={<ModalContent {...props} />}
        header={I18n.t('projects.show.stats.create_fundraising_event_modal_headline')}
        size="modal-lg"
      />
    </div>
  )
}

const ModalContent = ({ readmoreUrl, ctaUrl }: CreateFundraisingEventButtonModalContentProps): JSX.Element => (
  <div>
    <img src={teaserImage} width="100%" className="mb-3" />

    <span>{I18n.t('projects.show.stats.create_fundraising_event_modal_explanation')}</span>

    <div className="text-center mt-4">
      <a
        className="btn btn-primary btn-large"
        href={ctaUrl}
        target="_blank"
        onClick={() => gaEvent('navigation', 'click fe_modal__create_button')}
        rel="noreferrer"
      >
        {I18n.t('projects.show.stats.create_fundraising_event_modal_cta')}
      </a>
    </div>

    <div className="text-center mt-3">
      <a
        href={readmoreUrl}
        target="_blank"
        onClick={() => gaEvent('navigation', 'click fe_modal__read_more_link')}
        rel="noreferrer"
      >
        {I18n.t('projects.show.stats.create_fundraising_event_modal_readmore')}
      </a>
    </div>
  </div>
)
